import React, { useEffect, useState } from "react";
import banner1 from "../../../images/banner1.png";
import banner2 from "../../../images/banner2.png";


const banners = [
  { image: banner1 },
  { image: banner2 },
  { image: banner1 },
  { image: banner2 },
  { image: banner1 },
  { image: banner2 },
];

function MyCarousel() {
  const [current, setCurrent] = useState(0);

  const visibleCards = 3;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev >= banners.length - visibleCards ? 0 : prev + 1
      );
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-wrapper">
      <div
        className="carousel-track"
        style={{
          transform: `translateX(-${current * (100 / visibleCards)}%)`,
        }}
      >
        {banners.map((banner, index) => (
          <div className="carousel-card" key={index}>
            <img key={index} src={banner.image} alt="" />
          </div>
        ))}
      </div>

      <div className="dots">
        {Array.from({
          length: banners.length - visibleCards + 1,
        }).map((_, index) => (
          <span
            key={index}
            className={current === index ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default MyCarousel;